window.addEventListener('DOMContentLoaded', () => {
  $('.text-image-carousel-container').slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 2,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    cssEase: 'ease-in-out',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          centerPadding: '80px'
        }
      }
    ]
  });
})